import Layout from "@/views/main/Main.vue";
import type { RouteRecordRaw } from "vue-router";
const gaugeRouter: RouteRecordRaw = {
  path: "/gauge",
  component: Layout,
  redirect: "noredirect",
  meta: {
    icon: "icon-gongliangjuguanli1",
    title: "工量具管理"
  },
  children: [
    {
      path: "/gauge/basics",
      redirect: "noredirect",
      component: () => import("@/views/main/gauge/basics.vue"),
      name: "basics",
      meta: {
        title: "工量具基础信息"
      },
      children: [
        {
          path: "/gauge/basics/essential",
          component: () => import("@/views/main/gauge/basics/essential/essential.vue"),
          name: "essential",
          meta: {
            title: "工量具基础数据"
          }
        },
        {
          path: "/gauge/basics/recipient",
          component: () => import("@/views/main/gauge/basics/recipient/recipient.vue"),
          name: "recipient",
          meta: {
            title: "工量具领用人员信息"
          }
        }
      ]
    },
    {
      path: "/gauge/putIn",
      component: () => import("@/views/main/gauge/putIn/putIn.vue"),
      name: "putIn",
      meta: {
        title: "工量具入库"
      }
    },
    {
      path: "/gauge/manage",
      component: () => import("@/views/main/gauge/manage/manage.vue"),
      name: "manage",
      meta: {
        title: "工量具管理"
      }
    },
    {
      path: "/gauge/return",
      component: () => import("@/views/main/gauge/return/return.vue"),
      name: "return",
      meta: {
        title: "工量具归还"
      }
    },
    {
      path: "/gauge/history",
      component: () => import("@/views/main/gauge/history/history.vue"),
      name: "history",
      meta: {
        title: "历史记录查询"
      }
    }
  ]
};

//盘点路由
export default gaugeRouter;
